import script from "./CalcInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CalcInfo.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__